import {Skeleton} from '@kaman/uikit';

const ProductCardSkeleton = () => (
    <div className="min-w-0 overflow-hidden rounded-xl border border-gray-100 p-3">
        <Skeleton
            variant="rectangular"
            width="100%"
            height={150}
            className="!rounded-lg"
        />
        <div className="mt-3 flex flex-col gap-2">
            <Skeleton variant="rectangular" width="85%" height={22} className="!rounded" />
            <Skeleton variant="rectangular" width="60%" height={18} className="!rounded" />
            <Skeleton variant="rectangular" width="45%" height={20} className="!rounded" />
        </div>
    </div>
);

export default function OnlineSearchSkeleton({
    showSearchBar = true,
}: {
    showSearchBar?: boolean;
}) {
    return (
        <main
            className="flex w-full min-w-0 flex-col gap-5"
            dir="rtl"
            aria-busy="true"
            aria-label="در حال بارگذاری نتایج جستجوی فروشگاه‌های آنلاین"
        >
            {showSearchBar ? (
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={48}
                    className="!rounded-lg"
                />
            ) : null}

            <section className="flex w-full min-w-0 flex-col gap-3">
                <Skeleton variant="rectangular" width="38%" height={28} className="!rounded" />
                <div className="grid w-full min-w-0 grid-cols-2 gap-3">
                    {Array.from({length: 4}, (_, index) => (
                        <ProductCardSkeleton key={index} />
                    ))}
                </div>
            </section>
        </main>
    );
}
